module.exports = __webpack_public_path__ + "static/media/NEWSEVENTS1.0c0fff92.jpg";